import { IUser, IUserSongsHistory } from "../@types/interface.d";

export default class UserAPI {
  public static async verify(userId: string, token: string): Promise<IUser> {
    return fetch(`/api/user/${userId}/verify`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "tohokusan",
      },
      body: JSON.stringify({ token }),
    }).then(res => res.json());
  }

  public static async get(userId: string): Promise<IUser> {
    return fetch(`/api/user/${userId}`, {
      method: "GET",
    }).then(res => res.json());
  }

  public static async create(): Promise<IUser> {
    return fetch("/api/user", {
      method: "POST",
      body: "",
    }).then(res => res.json());
  }

  public static async update(user: IUser, token: string) {
    const json = {
      ...user,
      token,
    };
    fetch("/api/user", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "tohokusan",
      },
      body: JSON.stringify(json),
    });
  }

  public static async histories(userId: string): Promise<IUserSongsHistory[]> {
    return fetch(`/api/user/${userId}/history`, {
      method: "GET",
    }).then(res => res.json());
  }
}
